import {
  DownOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from "@ant-design/icons";
import { Button, Dropdown, Space, Tag } from "antd";
import { useDispatch, useSelector } from "react-redux";

import { Link, useNavigate } from "react-router-dom";
import { logOut, selectUser } from "store/slices";
import "./style.css";

const UserProfile = ({ name = "Jane Doe", email = "janedoe@gmail.com" }) => {
  return (
    <div className="flex items-center  text-text py-6 px-4 text-white">
      {/* <img
        src="/favicon-32x32.png"
        alt="User Avatar"
        className="w-10 h-10 rounded-full mr-4"
      /> */}
      <div className="flex flex-col">
        <span className="text-sm font-semibold text-text">{name}</span>
        <span className="text-xs">{email}</span>
      </div>
    </div>
  );
};

const KicHeader = ({
  collapsed,
  setCollapsed,
  openMobileMenu,
}: {
  collapsed: boolean;
  setCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
  openMobileMenu: () => void;
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const user = useSelector(selectUser);

  const logoutHandler = () => {
    dispatch(logOut());
    navigate("/");
  };

  const items = [
    {
      label: <Link to="/dashboard/profile">Profile</Link>,
      key: "0",
    },
    {
      label: <Link to="/dashboard/transactions">Transactions</Link>,
      key: "1",
    },
    {
      label: (
        <button
          type="button"
          onClick={logoutHandler}
          style={{
            border: "none",
            backgroundColor: "transparent",
            color: "rgb(49, 56, 62)",
            cursor: "pointer",
            width: "100%",
            textAlign: "left",
          }}
        >
          Logout
        </button>
      ),
      key: "3",
    },
  ];
  return (
    <div>
      <div className="max-lg:hidden flex items-center justify-between ">
        {" "}
        <Button
          type="text"
          className="header__button"
          icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          onClick={() => setCollapsed(!collapsed)}
          style={{
            fontSize: "16px",
            width: 64,
            height: 64,
          }}
        />
        <div>
          <Tag color="success" className="font-semibold">
            Subscription is active
          </Tag>
          <Dropdown
            menu={{
              items,
            }}
            trigger={["click"]}
            className="!font-sans"
          >
            <button type="button" onClick={(e) => e.preventDefault()}>
              <Space>
                <div
                  style={{
                    height: 42,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 8,
                    backgroundColor: "rgba(49, 56, 62, 0.05)",
                    padding: "12px",
                    borderRadius: "8px",
                    color: "rgb(49, 56, 62)",
                  }}
                >
                  <h4 className="font-sans font-bold capitalize">
                    {user?.username}
                  </h4>
                  <DownOutlined />
                </div>
              </Space>
            </button>
          </Dropdown>
        </div>
      </div>
      <div className="header__mobile">
        <button
          type="button"
          onClick={openMobileMenu}
          className="flex items-center gap-2 !w-auto !p-0 !bg-transparent "
        >
          {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          Menu
        </button>
        <div className="header__desktop">
          <UserProfile email={user?.email} name={user?.name?.split(" ")[1]} />
        </div>
        <button type="button" onClick={logoutHandler}>
          <LogoutOutlined />
        </button>
      </div>
      <div className="sm:hidden flex items-center justify-end"></div>
    </div>
  );
};

export default KicHeader;
